<template>
    <el-form v-if="model" ref="form" :model="model" :rules="rules" label-width="120px" label-position="top" size="mini">
        <el-form-item label="栏目名称" prop="name">
            <el-input v-model="model.name"></el-input>
        </el-form-item>
    </el-form>
</template>

<script>
    import sectionService from '../../service/section'

    export default {
        name: "PieSectionConfigForm",
        props: {
            id: Number
        },
        data() {
            return {
                dirty: false,
                model: null,
                rules: {
                    name: [
                        {required: true, message: '请输入栏目名称', trigger: 'blur'},
                        {min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur'},
                    ]
                }
            }
        },
        created(){
            this.init()
        },
        watch: {
            id() {
                this.init()
            },
            model: {
                handler(newValue, oldValue) {
                    // 只有model引用不变而内容发生变化时才将dirty设置为true
                    this.dirty = newValue === oldValue
                },
                deep: true
            }
        },
        methods: {
            async init(){
                const response = await sectionService.getSection(this.id)
                const model = response.data
                if(model.config){
                    model.config = JSON.parse(model.config)
                }else{
                    model.config = {}
                }
                this.model = model
                this.dirty = false
            },
            isDirty() {
                return this.dirty
            },
            async save(){
                await this.$refs.form.validate()
                const data = JSON.parse(JSON.stringify(this.model))
                data.config = JSON.stringify(data.config)
                await sectionService.updateSection(data)
                this.dirty = false
            }
        }
    }
</script>

<style scoped>

</style>
